var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _AjaxLoader_ajaxLoader;
import { AjaxLoaderRequest } from './ajax-loader-request';
import { StickyHeader } from './sticky-header';
import { Carousels } from './carousels';
import { SubFeaturesEqualHeight } from './sub-features-equal-height';
export class AjaxLoader {
    constructor() {
        _AjaxLoader_ajaxLoader.set(this, void 0);
        __classPrivateFieldSet(this, _AjaxLoader_ajaxLoader, new AjaxLoaderRequest(this.getApiUrl(), this.isMobileShop()), "f");
        window.shell.subscribeTo('AAS.update', this.update.bind(this), 'AAS.update');
    }
    getApiUrl() {
        var _a, _b;
        return (_b = (_a = document.querySelector('.scope-aas')) === null || _a === void 0 ? void 0 : _a.dataset.apiurl) !== null && _b !== void 0 ? _b : '';
    }
    isMobileShop() {
        return document.documentElement.classList.contains('mobileshop');
    }
    queryAas(content) {
        return document.querySelectorAll(`.scope-aas${content ? `[data-content="${content}"]` : ''}`);
    }
    update(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const { savKeyToLoad, content: targetContent } = event.detail;
            const scopesToUpdate = this.queryAas(targetContent);
            scopesToUpdate.forEach((scope) => this.updateOneScope(scope, savKeyToLoad));
        });
    }
    isTrue(value) {
        return (value === null || value === void 0 ? void 0 : value.toLowerCase()) === 'true';
    }
    updateOneScope(scope, savKeyToLoad) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const content = (_a = scope.dataset.content) !== null && _a !== void 0 ? _a : '';
            const ajaxResponse = yield __classPrivateFieldGet(this, _AjaxLoader_ajaxLoader, "f").requestFor(savKeyToLoad, content, (_b = scope.dataset.itemOrigin) !== null && _b !== void 0 ? _b : '', this.isTrue(scope.dataset.detailsCanBeHidden), (_c = scope.dataset.displayedInCategoryNavkey) !== null && _c !== void 0 ? _c : '', this.isTrue(scope.dataset.showHeader));
            if (!ajaxResponse) {
                window.shell.publishTo('AAS.updateError', {
                    detail: {
                        content,
                        message: `Error loading AAS for ${savKeyToLoad}`,
                        savKeyToLoad,
                    },
                });
                return;
            }
            this.replace(ajaxResponse, content);
            this.initJsComponents(savKeyToLoad, content);
            const payload = {
                detail: { queryString: `.scope-aas[data-sav-key="${savKeyToLoad}"][data-content="${content}"]` },
            };
            window.shell.publishTo('AAS.updateFinished', payload);
            if (content === 'full') {
                const newAas = this.queryAas(content)[0];
                window.shell.publishTo('ManualProductComparison.CreateTouchPoints', newAas);
                newAas.querySelectorAll('a[data-quick-order-modal]').forEach((basketLink) => basketLink.addEventListener('click', this.redesignOrderModalLinkCallback.bind(this)));
            }
            if (document.documentElement.classList.contains('desktop')) {
                this.addTabNavigationEvents(content);
                setTimeout(() => this.addTabNavigationToMpcButtons(content), 300);
            }
        });
    }
    redesignOrderModalLinkCallback(event) {
        const target = event.currentTarget;
        window.shell.publishTo('ESPP.OrderModal.Open', {
            salesArticleNo: target.dataset.salesarticleno,
            masterArticleNo: target.dataset.masterarticleno,
            colorCode: target.dataset.colorcode,
            sizeCode: target.dataset.sizecode,
            itemOrigin: target.dataset.itemorigin,
        });
    }
    initJsComponents(savKey, content) {
        const newAas = this.queryAas(content)[0];
        if (this.isMobileShop()) {
            new StickyHeader(savKey, content);
            window.shell.once('AAS.view.shown', () => {
                new Carousels(newAas);
                new SubFeaturesEqualHeight(newAas);
            });
        }
        else {
            new SubFeaturesEqualHeight(newAas);
        }
        newAas.querySelectorAll('a[data-itemorigin]').forEach((link) => {
            const isOrderModalLink = link.hasAttribute('data-quick-order-modal');
            if (!isOrderModalLink) {
                ['mouseover', 'touchstart'].forEach((event) => link.addEventListener(event, () => {
                    if (!link.href.includes('itemorigin')) {
                        const containsQueryParameter = link.href.includes('?');
                        link.href += `${containsQueryParameter ? '&' : '?'}itemorigin=${link.dataset.itemorigin}`;
                    }
                }));
            }
        });
    }
    addTabNavigationToMpcButtons(content) {
        const newAas = this.queryAas(content)[0];
        newAas.querySelectorAll('.mpc-scope.scale-tile-container').forEach((button) => {
            button.setAttribute('role', 'button');
            button.setAttribute('focusable', 'true');
            button.addEventListener('keydown', (event) => {
                if (event.key === 'Enter')
                    button.click();
            });
        });
    }
    addTabNavigationEvents(content) {
        const newAas = this.queryAas(content)[0];
        newAas.addEventListener('keydown', (event) => {
            if (event.code === 'Space')
                event.preventDefault();
        });
        ['.view-button', '.separator'].forEach((selector) => newAas.querySelectorAll(selector).forEach((div) => div.addEventListener('keydown', (event) => {
            if (event.key === 'Enter')
                div.click();
        })));
        ['.index-product a', '.aas-button.basket a'].forEach((selector) => newAas.querySelectorAll(selector).forEach((anchor) => anchor.addEventListener('keydown', (event) => {
            if (event.code === 'Space')
                anchor.click();
        })));
    }
    replace(response, content) {
        var _a;
        const newAas = new DOMParser().parseFromString(response, 'text/html').querySelector('.scope-aas');
        const aasToReplace = document.querySelector(`.scope-aas[data-content="${content}"]`);
        (_a = aasToReplace === null || aasToReplace === void 0 ? void 0 : aasToReplace.parentNode) === null || _a === void 0 ? void 0 : _a.replaceChild(newAas, aasToReplace);
    }
    triggerAppShellUpdate(savKeyToReplace, savKeyToLoad, content, target) {
        const payload = { detail: { savKeyToReplace, savKeyToLoad, content, target } };
        window.shell.publishTo('AAS.update', payload);
    }
}
_AjaxLoader_ajaxLoader = new WeakMap();
